import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const TitleTag = styled(Text)(({ theme }) => ({
    marginBottom: theme.spacing.xxSmall,
}));

export const DeliveryTagWrapper = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: theme.spacing.xxSmall,
}));

export const DeliveryTagImageWrapper = styled.div(({ theme }) => ({
    display: "inline-block",
    marginLeft: theme.spacing.xSmall,
    width: "70px",
    height: "20px",
}));

export const HeaderCTAWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-shrink: 0;
    margin-left: ${({ theme }) => theme.spacing.small};
    width: 90px;
`;

export const HeaderCTAIconWrapper = styled.div(({ theme }) => {
    return {
        marginLeft: theme.spacing.xSmall,
        display: "inline-block",
        width: "12px",
        height: "12px",
    };
});

export const RestrictedItemSeperatorNodeText = styled(Text)(({ theme }) => ({
    marginBottom: theme.spacing.medium,
}));

export const ItemCounterWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-shrink: 0;
    margin-left: ${({ theme }) => theme.spacing.small};
    width: 60px;
`;
